const billingStatuses = {
    BLOCKED: 'BLOCKED',
    LIMITED: 'LIMITED',
    RUNNING_LOW: 'RUNNING_LOW'
};

export default billingStatuses;